
const Items = [
  {
    id: 1,
    name: "Students",
    url: "#",
    hasSubmenu: true,
    display:"none",
    subMenuItems: [
      {
        subId: 1,
        name: "Profile",
        url: "/students/profile",
      },
      {
        subId: 2,
        name: "Degree Plan",
        url: "/students/degree",
        display:"block",  
      },
      {
        subId: 3,
        name: "Classes",
        url: "/students/classes",
      },
      {
        subId: 4,
        name: "Schedule",
        url: "/students/schedule",
        display:"block", 
      },
      {
        subId: 5,
        name: "My Final Grades",
        url: "/students/grades",
        display:"block",  // Hidden
      },
      {
        subId: 6,
        name: "Select Classes",
        url: "/students/select-class",
        display:"block", 
      },
      // {
      //   subId: 7,
      //   name: "Activity",
      //   url: "#",
      // },
      {
        subId: 8,
        name: "Learning & Management",
        url: "https://ecampus.ustboniface.ca/",
        display:"none",  // Hidden
      },
    ],
  },
  {
    id: 2,
    name: "Mes études",
    url: "#",
    hasSubmenu: true,
    display:"none",
    subMenuItems: [
      {
        subId: 1,
        name: "eCAMPUS",
        url: "https://ecampus.ustboniface.ca/",
      },
      {
        subId: 2,
        name: "Tutorat",
        url: "https://ustboniface.ca/monusb-tutorat",
      },
      {
        subId: 3,
        name: "Orientation académique",
        url: "https://ustboniface.ca/monusb-orienteurs",
      },
      {
        subId: 4,
        name: "Service d’accessibilité aux études",
        url: "https://ustboniface.ca/monusb-service-daccessibilite-aux-etudes",
      },
    ],
  },
  {
    id: 3,
    name: "Ma boîte à outils",
    url: "#",
    hasSubmenu: true,
   display:"none",
    subMenuItems: [
      {
        subId: 1,
        name: "Cartes étudiantes et d’autobus",
        url: "https://ustboniface.ca/sportexgym/monusb/carte-etudiante",
      },
      {
        subId: 2,
        name: "Stationnement",
        url: "https://ustboniface.ca/monusb/stationnement-etudiant",
      },
      {
        subId: 3,
        name: "Service de soutien au bienêtre et à la santé mentale",
        url: "https://ustboniface.ca/monusb-service-de-soutien-psychologique",
      },
      {
        subId: 4,
        name: "Matériel de laboratoire",
        url: "https://ustboniface.ca/monusb2023/materiel-de-laboratoire",
      },
    ],
  },

  {
    id: 4,
    name: "Faculty & Staff",
    url: "#",
    hasSubmenu: true,
    display:"none",
    subMenuItems: [
      {
        subId: 1,
        name: "Profile",
        url: "/faculty/profile",
        display:"none",
      },
      {
        subId: 2,
        name: "Classes",
        url: "/faculty/classes",
      },
      {
        subId: 3,
        name: "Enter Attendance",
        url: "/faculty/attendance",
        display:"none",
      },

      {
        subId: 4,
        name: "Tests & Scores",
        url: "/faculty/testandscore",
        display:"none",
      },
      {
        subId: 5,
        name: "Learning & Management",
        url: "https://ecampus.ustboniface.ca/",
        display:"none",
      },
      {
        subId: 6,
        name: "Attendance Report",
        url: "/faculty/attendancereport",
        display:"none",
      },
    ],
  },
  {
    id: 5,
    name: "Parents",
    url: "#",
    hasSubmenu: true,
    display:"none",
    subMenuItems: [
      {
        subId: 1,
        name: "Profile",
        url: "/parents/profile",
      },
      {
        subId: 2,
        name: "Attandance",
        url: "#",
      },
      {
        subId: 3,
        name: "Grades",
        url: "#",
      },
    ],
  },
  {
    id: 6,
    name: "Alumni",
    url: "#",
    hasSubmenu: true,
    display:"none",
    subMenuItems: [
      {
        subId: 1,
        name: "My Information",
        url: "/alumni/profile",
      },
      {
        subId: 2,
        name: "Events",
        url: "/alumni/events",
      },
      {
        subId: 3,
        name: "Opportunities",
        url: "/alumni/opportunities",
      },
      {
        subId: 4,
        name: "Donations",
        url: "#",
      },
    ],
  },
  {
    id: 7,
    name: "Events",
    url: "/events",
    hasSubmenu: false,
    display:"none",
    subMenuItems: [],
  },
  {
    id: 8,
    name: "Course Catalog",
    url: "/coursecatalog",
    hasSubmenu: false,
    display:"block",
    subMenuItems: [],
  },
  {
    id: 9,
    name: "Documents",
    url: "/documents",
    hasSubmenu: false,
    display:"none",
    subMenuItems: [],
  },
  {
    id: 10,
    name: "Mes finances",
    url: "#",
    hasSubmenu: true,
    display:"block",
    subMenuItems: [
      {
        subId: 1,
        name: "Factures",
        url: "/account",
      },
      {
        subId: 2,
        name: "FAQ sur la facture",
        url: "https://ustboniface.ca/monusb2023/facture-faq",
      },
    ],
  },
  {
    id: 11,
    name: "About",
    url: "#",
    hasSubmenu: false,
    display:"none",
    subMenuItems: [],
  },
  {
    id: 12,
    name: "Inscription",
    url: "#",
    hasSubmenu: true,
    display:"none",
    subMenuItems: [
      {
        subId: 1,
        name:  "Inscription collégiale",
        url: "https://ustboniface.ca/monusb/inscription-collegiale",
      },
      {
        subId: 2,
        name:"Inscription universitaire (1er cycle)",
        url: "https://ustboniface.ca/monusb/inscription-universitaire",
      },
      {
        subId: 3,
        name:  "Inscription universitaire (2e cycle)",
        url: "https://ustboniface.ca/monusb/inscription-2ecycle",
      },
    ],
  },
  {
    id: 13,
    name: "Application",
    url: "#",
    hasSubmenu: true,
    display:"none",
    subMenuItems: [
      {
        subId: 1,
        name: "Application Home",
        url: "/prospective/landingpage",
      },
    ],
  },
];

export default Items;
